import React, { useEffect, useRef, useState } from 'react'
import './SimilarProducts.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import CommonHeadingBeforeAfterLine from '../../Common-Component/CommonHeadingBeforeAfterLine/CommonHeadingBeforeAfterLine';
import Shop_by_shapes_cards from '../../Common-Component/Shop_by_shapes_cards/Shop_by_shapes_cards';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProductsNewLaunch } from '../../../features/products/productsSlice';

const SimilarProducts = ({product}) => {

    const swiperRef = useRef(null);
    const [swiperInstance, setSwiperInstance] = useState(null);

    const slides = Array(9).fill(null);
    const dispatch = useDispatch();
    const productdata = useSelector(
        (state) => state.product.allProductsNewLaunch
      );
      useEffect(() => {
        dispatch(
          getAllProductsNewLaunch({
            type: "new-launch",  category_id: product?.category_id,       
          })
        );
      }, [dispatch,product?.category_id]);
    return (
        <section className='SimilarProducts'>
            <div className='heading_div'>
                <CommonHeadingBeforeAfterLine headingText="Similar Products" />
            </div>

            <div className='products_swiper_div'>
                <Swiper
                    spaceBetween={40}
                    slidesPerView={5}
                    breakpoints={{
                        0: {
                            slidesPerView: 2.5,
                            spaceBetween: 10,
                        },
                        420: {
                            slidesPerView: 3.5,
                            spaceBetween: 10,
                        },
                        485: {
                            slidesPerView: 3.5,
                            spaceBetween: 10,
                        },
                        640: {
                            slidesPerView: 4.5,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 5,
                            spaceBetween: 30,
                        },
                        1280: {
                            slidesPerView: 5,
                            spaceBetween: 40,
                        },
                    }}
                >

                    {productdata?.length > 0 && productdata?.map((item) => {
                        return (
                            <SwiperSlide >
                                <Shop_by_shapes_cards val={item}/>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>

        </section>
    )
}

export default SimilarProducts
